<template>
  <div class="altertips" :class="type">
    <svg
      class="icon-svg icon-svg--size-24 notice__icon"
      aria-hidden="true"
      focusable="false"
    >
      <use xlink:href="#error">
        <svg id="error">
          <svg  viewBox="0 0 24 24">
            <path
              d="M12 24C5.373 24 0 18.627 0 12S5.373 0 12 0s12 5.373 12 12-5.373 12-12 12zm0-2c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10zm0-16c.552 0 1 .448 1 1v5c0 .552-.448 1-1 1s-1-.448-1-1V7c0-.552.448-1 1-1zm-1.5 10.5c0-.828.666-1.5 1.5-1.5.828 0 1.5.666 1.5 1.5 0 .828-.666 1.5-1.5 1.5-.828 0-1.5-.666-1.5-1.5z"
            ></path>
          </svg>
        </svg>
      </use>
    </svg>
    <p class="tips_content" v-html="message"></p>
  </div>
</template>
<script>
export default {
  props: {
    type: {
      type: [String],
      default: "error",
    },
    message: {
      type: [String]
    },
  },
  data() {
    return {};
  },
};
</script>
<style scoped lang='scss'>
.error {
  border-color: #fad9d9 !important;
  background-color: #ffebeb !important;
  svg{
    path{
      fill:#e32c2b;
    }
  }
}
.altertips {
  width: 100%;
  position: relative;
  display: table;
  opacity: 1;
  margin-top: 21px;
  margin-bottom: 20px;
  padding: 14px;
  border-radius: 4px;
  border: 1px solid #d3e7f5;
  background-color: #eff8ff;
  color: #545454;
  -webkit-transition: opacity 0.5s ease-in-out;
  transition: opacity 0.5s ease-in-out;
  svg{
    width: 24px;
    height: 24px;
    margin-top: -2px;
    margin-right: 10px;
  }
  p{
      margin: 0;
      display: table-cell;
      width: 100%;
      font-size: 14px;
      color: #545454;
  }
}
</style>